
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/weingut/geschichte",
      function () {
        return require("private-next-pages/weingut/geschichte.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/weingut/geschichte"])
      });
    }
  